import { SET_RATES_VARIABLES_PAYLOAD,SET_FORMULA_FIELD_DATA,SET_MAPPING_FIELD_DATA, SET_VARIABLE_FIELD,SET_AUTO_MAPPING_FIELD,SET_AUTO_MAPPING_FILTERED_FIELD } from "../actionTypes/RatingVariableTypes";



const initialState = {
  variableFields:{
    field_type:[],
    variable_type:[]
  },
  arrayObjectFields:{},
  windowFields:{},
  variablesPayload:[],
  mappingFields:[],
  autoMappingFields:[],
  autoMappingFilteredFields:[],
  formulaFieldsData:{
    functions:[],
    operators:[],
    supported_fields:[]
  },
  inputValuesPayload:[],
  apiResponse:{type:'SINGLE',data:[],reqIndex:null,isSideBarOpen:true},
  selectedCollectionId:0,
  selectedHistoryId:null,
  selectedObj:{},
  relatedWindowFields:{},
    collectionDetails:{
        collection_name: "",
        description: "",
        window_id: "",
        related_windows: [],
        module_id:'',
        is_collection: false,
        collection_filters: [],
        api_requests: [],
        collection_variables:[],
        
    },
    
};
const RatingVariableReducer = (state = initialState, action) => {
  // const {variablesPayload} = state;
  const {payload,type} = action
  switch (type) {
      case SET_RATES_VARIABLES_PAYLOAD:
      return{
          ...state,
          variablesPayload:payload
        }
      case SET_VARIABLE_FIELD:
        return{
          ...state,
          variableFields:payload
        }
      case SET_AUTO_MAPPING_FIELD:
        return{
          ...state,
          autoMappingFields:payload
        }  
      case SET_AUTO_MAPPING_FILTERED_FIELD:
            return{
              ...state,
              autoMappingFilteredFields:payload
            } 
      case SET_MAPPING_FIELD_DATA:
            return{
              ...state,
              mappingFields:payload
            }   
       case SET_FORMULA_FIELD_DATA:
            return{
              ...state,
              formulaFieldsData:payload
            }              
    default:
          return state;
    }
}
export default RatingVariableReducer;